import React,{useState,useEffect} from 'react';
import MenuPreview from './menuPreview';
import RodapePreview from './rodapePreview';
import {DivCentralizaItensCarrossel,
    DivCarrosselLetreiroCentro,
    DivLetreiroCentro,
    H1Letreiro,
    PLetreiro,
    DivCarrossel,
    DivTextoChamativo,
    DivInternaTextoChamativo,
    PTextoChamativo,
    DivTextoApresentacao,} from './styleIndexPreview';

import {IconVoltar,IconAvancar} from './styleIndexPreview';
import {IconQuotInicio,IconQuotFinal } from './styleIndexPreview';
import {GetCurrentUser} from '../../services/servicesGetCurrentUser';
import {URLIMG} from '../../helpers/constantes'

export default function PreviewInicio(){
    const [count, setCount]=useState(0);
    const [carrosselBackground, setCarrosselBackground ] = useState([]);
    const [carrosselCaption, setCarrosselCaption ] = useState([]);
    const [carrosselDescription, setCarrosselDescription] = useState([]);
    const [logo, setLogo] = useState('');
    const [dadosUsuarios, setDadosUsuarios] = useState({})

    function AvancaImagemFundo(){

        if((count + 1) == carrosselBackground.length){
            setCount(0)
        }else{

            setCount(count+1);
        }
    }
    function VoltaImagemFundo(){
        if((count - 1 ) == -1){
            setCount(carrosselBackground.length - 1);
        }else{
            setCount(count-1);
        }
    };

    async function CarregaDadosPerfil(){
        try{
        const dados = await GetCurrentUser();
        setCarrosselBackground([dados.SliderPicture1,dados.SliderPicture2,dados.SliderPicture3]);
        setCarrosselCaption([dados.SliderCaption1,dados.SliderCaption2,dados.SliderCaption3]);
        setCarrosselDescription([dados.SliderDescription1,dados.SliderDescription2,dados.SliderDescription3]);
        setLogo(dados.LogoHeader);
        setDadosUsuarios(dados);
        }catch(error){
            console.log(error)
        }

    }
    useEffect(()=>{
        CarregaDadosPerfil();
    },[])

    return(<div style={{overflow:'auto',background:'#fff',height:'100vh',width:'100vw',}}>
        <MenuPreview dadosUsuario={dadosUsuarios}/>
        <DivCarrossel style={{backgroundImage: `url(${URLIMG + carrosselBackground[count]})`}}>
            <DivCentralizaItensCarrossel>
                <div onClick={VoltaImagemFundo}><span><IconVoltar/></span></div>
                <DivCarrosselLetreiroCentro>
                    <DivLetreiroCentro>
                        <H1Letreiro>
                            {carrosselCaption.length > 0 ? carrosselCaption[count]:''}
                        </H1Letreiro>
                        <PLetreiro>
                            {carrosselDescription.length > 0 ? carrosselDescription[count]:''}
                        </PLetreiro>
                    </DivLetreiroCentro>
                </DivCarrosselLetreiroCentro>
                <div onClick={AvancaImagemFundo} style={{justifyContent:'flex-end',display:'flex'}}>
                    <span><IconAvancar/></span>
                </div>
            </DivCentralizaItensCarrossel>
        </DivCarrossel>
        <DivTextoApresentacao>
            <DivInternaTextoChamativo>
                <PTextoChamativo>
                    {dadosUsuarios.DescriptionWelcome}
                </PTextoChamativo>
            </DivInternaTextoChamativo>
        </DivTextoApresentacao>
        <RodapePreview />
    </div>)
}
